const LOGIN_PATH = "/login/";
const REGISTER_PATH = "/register/";
const CREATE_PARTY_PATH = "/party/";
const CREATED_PARTY_PATH = "user/party/created/";
const REQUEST_PARTY_PATH = "user/party/created/info/";
const JOINED_PARTY_PATH = "user/party/joined/";
const ACCEPTED_REQUEST_USER_PATH = "party/accept/";
const DECLINED_REQUEST_USER_PATH = "party/decline/";
const REQUEST_JOIN_PARTY_PATH = "/party/request/";
const REQUESTED_PARTY_PATH = "user/party/requested/";

export {
  LOGIN_PATH,
  REGISTER_PATH,
  CREATE_PARTY_PATH,
  CREATED_PARTY_PATH,
  REQUEST_PARTY_PATH,
  JOINED_PARTY_PATH,
  ACCEPTED_REQUEST_USER_PATH,
  DECLINED_REQUEST_USER_PATH,
  REQUEST_JOIN_PARTY_PATH,
  REQUESTED_PARTY_PATH,
};
